import type { FaireThemeEntity } from "../../entity_types/theme";

export const soft_knits_for_mom_and_mini: FaireThemeEntity = {
  token: "soft-knits-for-mom-and-mini",
  type: "theme",
  name: "Soft Knits for Mom & Mini",
  description: "Cozy, high-quality knitwear for both women and babies that matches your shop's focus on family and comfort.",
  teaser: "Your order history shows a strong commitment to baby gowns and women's knit sweaters, making these pom-pom hats and cardigans a perfect fit for your customer base.",
  detail: "The cart data includes the Baby's Pom Pom Knitted Hat and the Contrast Print Cardigan, illustrating a curated selection for multi-generational shoppers.",
  bgColor: "#E8D4E8",
  tileBgColor: "#6b4631",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_kumzeswk5m",
    "p_ezf2fjapy5",
    "p_jph4gae55y",
    "p_m7hyadv9ny",
    "p_t7g6vfr45f",
    "p_aqw92qdw6w",
    "p_j6by73u5py",
    "p_kuuxswrvwc",
    "p_34xyv6zu5q",
    "p_g8zmnk45us",
    "p_ax42ytu9uz",
    "p_65t5hnjzur",
    "p_8mggyzxx4g",
    "p_7gxxwh45jk",
    "p_6nt3g6dzvf",
    "p_trpp5ad4tc",
    "p_3txpkmd7ya",
    "p_9xl7ztkziw",
    "p_uswwmaczta",
    "p_2bfzvcqu4h",
    "p_8c48nqb6ug",
    "p_px39suuz5c",
    "p_k49jxsamfp",
    "p_jwpq7757cp",
    "p_2mkf5yenr2",
    "p_gmj8tudb62",
    "p_upx548rnan",
    "p_8za39ngd6v",
    "p_5nevqgdm7f",
    "p_yjszp2vv28",
    "p_n5sh7c4r4r",
    "p_gapng3nshg",
    "p_qgrg4tcvgg",
    "p_bw94td7rmq",
    "p_fjxkcwfyuq",
    "p_24vjy4sgzg",
    "p_c4v376739z",
    "p_7ugfqwtar8",
    "p_ga2x7x75n5",
    "p_qrnqqgty88",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
